import React from "react";
import moment from "moment";

import {
  DumpsterSize,
  MaterialDisposing,
  Order,
  dumpsterSizeToText,
  materialDisposingToText,
} from "../../../../models";

import "./CustomerDetailsCard.scss";
import { PhoneNumber } from "../../../../components";

export interface CustomerDetailsCardProps {
  order: Order;
}

export function CustomerDetailsCard(props: CustomerDetailsCardProps) {
  const { order } = props;

  return (
    <div className="customer-details-card-component">
      <div className="title">Customer Details</div>

      <div className="details-container">
        <div className="column">
          <div className="item-container">
            <div className="label">Name:</div>
            <div className="value">{order.name}</div>
          </div>

          <div className="item-container">
            <div className="label">PO:</div>
            <div className="value">{order.po || ""}</div>
          </div>
        </div>

        <div className="column">
          <div className="item-container">
            <div className="label">Email:</div>
            <div className="value">{order.email}</div>
          </div>

          <div className="item-container">
            <div className="label">Phone Number:</div>
            <div className="value">
              <PhoneNumber phoneNumber={order.phoneNumber} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
